import { useNavigate } from 'react-router-dom'
import { TaxDeductionCard } from '@/features/user/dashboard/insights-cards/TaxDeductionCard'
import { TaxDeductionTipCard } from '@/features/user/dashboard/insights-cards/TaxDeductionTipCard'
import { Text, Card, CardColors, Button, Alert } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useReselector } from '@/utils/sharedHooks'
import { selectOnboardingStepCompletedOrSkipped } from '@/features/onboarding/user-onboarding-steps/onboarding.selectors'
import { GettingStartedOnboardingStep } from '@/features/onboarding/user-onboarding-steps/onboarding.reducer'
import { useAnalyticsTrack } from '@/features/amplitude'

export const MaximizeTaxDeductionsCard = () => {
  const navigate = useNavigate()

  const isUploadBankStatementsComplete = useReselector(
    selectOnboardingStepCompletedOrSkipped,
    GettingStartedOnboardingStep.uploadBankStatements
  )

  const track = useAnalyticsTrack()

  const shouldShowDataNotFinalAlert = !isUploadBankStatementsComplete

  const buttonClassName = 'mt-4'

  return (
    <Card color={CardColors.LEVEL_1}>
      <Text variant={TypographyStyles.H2} className="w-full">
        Maximize Tax Deductions
      </Text>

      {shouldShowDataNotFinalAlert && (
        <div className="w-full mb-6 mt-6">
          <Alert variant="warning" title="Data pending">
            <div style={{ display: 'flex', gap: 16 }}>
              <Text variant={TypographyStyles.BODY_MD}>
                We need your <strong>bank statements</strong> to provide an
                accurate view of your tax deductions. Upload your statements so
                we can complete your catch-up bookkeeping.
              </Text>
              <Button
                onClick={() => {
                  track(
                    'Clicked Upload Statements Button in Practice Overview Alert'
                  )
                  navigate('/practice/documents?tab=bank')
                }}
                size="sm"
                className={buttonClassName}
              >
                Upload Statements →
              </Button>
            </div>
          </Alert>
        </div>
      )}

      <div className="flex flex-col lg:flex-row gap-6">
        <div className="lg:w-2/3 w-full">
          <TaxDeductionCard />
        </div>
        <div className="lg:w-1/3 w-full">
          <TaxDeductionTipCard />
        </div>
      </div>
    </Card>
  )
}
